export default __webpack_public_path__ + "static/media/Icon.c45721ea.png";